import {
  IItemCommercialTranslation,
  IItemCommercialTranslationData
} from '../itemcommercialtranslation.types';
import { ItemCommercialTranslation } from '../itemcommercialtranslation';

export const mockItemCommercialTranslationsData = (): IItemCommercialTranslationData[] => [
  {
    id: 59,
    field_name: 'description',
    language: 'en-US',
    language_code: 'ENU',
    language_description: 'English (United States)',
    text: 'SENSOR - CO2',
    identifier: '1000004'
  },
  {
    id: 60,
    field_name: 'description',
    language: 'es-ES',
    language_code: 'ESP',
    language_description: 'Spanish (Spain)',
    text: 'SENSOR - CO2',
    identifier: '1000004'
  }
];

export const mockItemCommercialTranslations = (
  data: IItemCommercialTranslationData[] = mockItemCommercialTranslationsData()
): IItemCommercialTranslation[] =>
  data.map(item => new ItemCommercialTranslation(item));
